import React from "react";
import { Route, Switch } from "react-router-dom";
import ViagemIndex from "./ViagemIndex";
import ViagemShow from "./ViagemShow";
import ViagemNew from "./ViagemNew";

export default function ViagemPage() {
  return (
    <Switch>
      <Route exact path="/viagens" component={ViagemIndex} />
      <Route path="/viagens/novo" component={ViagemNew} />
      <Route path="/viagens/:id" component={ViagemShow} />
    </Switch>
  );
}
